import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestAccess } from 'project/ducks/ndas';
import { toggleRightDrawer } from 'header/ducks';
import { toggleParticipateForm } from 'project/ducks/form';
import { canRequestProjectAccess, getParticipationForbiddenReason, canWatch } from 'project/utils';
import { withRouter } from 'react-router';
import last from 'lodash/last';
import HeaderButtons from 'project/components/header_buttons';

export function mapStateToProps(state, { routes }) {
  const lastRoute = last(routes);

  return {
    showFilters: lastRoute.name === 'entries' || lastRoute.name === 'your-entries',
    canRequestAccess: canRequestProjectAccess(state),
    canParticipate: !getParticipationForbiddenReason(state),
    canWatch: canWatch(state)
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleRightDrawer,
    toggleParticipateForm,
    requestAccess
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderButtons));



// WEBPACK FOOTER //
// ./project/containers/header_buttons.jsx